<div class="content-overview">
  <ul
    ngbNav
    id="container"
    #navOverview="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
  >
    <li ngbNavItem="tests" class="ms-xxl-7">
      <a ngbNavLink class="fw-semi-bold title-tab">
        <span class="icon">
          <img src="assets/icons/icon-test.svg" alt="tests" class="filter-grey"
        /></span>
        <span
          class="d-none d-lg-inline-block text-uppercase"
          i18n="@@patients_evaluationOverviewSurveys_testsLink"
          >Tests</span
        >
      </a>
      <ng-template ngbNavContent>
        <app-tests></app-tests>
      </ng-template>
    </li>
    <li ngbNavItem="surveys">
      <a ngbNavLink class="fw-semi-bold title-tab">
        <span class="icon icon-file">
          <img
            src="assets/icons/icon-survey.svg"
            alt="surveys"
            class="filter-grey"
        /></span>
        <span
          class="d-none d-lg-inline-block text-uppercase"
          i18n="@@patients_evaluationOverviewSurveys_surveysLink"
          >Surveys</span
        >
      </a>
      <ng-template ngbNavContent>
        <app-surveys
          (emitEvaluationCode)="sendCodeToDetail($event)"
        ></app-surveys>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="navOverview" class="mt-2"></div>
</div>
